import _isFunction from 'lodash/isFunction'

import * as mutationTypes from 'store/mutationTypes'

/**
 * @return {Promise}
 */
export const setCurrentDate = function ({ commit }, date) {
  if (!date) throw new Error('date')
  if (!date.isValid || !_isFunction(date.isValid) || !date.isValid())
    throw new Error('date must be a Moment object')

  return commit(mutationTypes.SET_CURRENT_DATE, date)
}



// WEBPACK FOOTER //
// ./src/store/modules/date/actions.js